import { tWithKeyAttr as t } from "./i18nHelper";
import React from "react";
import ReactDOM from "react-dom/client";
import "./styles/index.css";
import App from "./components/app/App";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import configureStore from "./services/store";
import { initI18n } from "./i18n";


const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
const renderApp = () => {
root.render(
  <React.StrictMode>
    <Provider store={configureStore}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);
};

// אתחול i18n קודם לטעינה
initI18n().then(() => {
  renderApp();
});
